import { type RefObject } from 'react';
import { type ScrollView } from 'react-native';
import { type SharedValue } from 'react-native-reanimated';

// ─────────────────────────────────────────────────────────────────────────────

export type Input = {
  defaultTargetId?: string;
  scrollOffset: SharedValue<number>;
  scrollViewRef: RefObject<{
    scrollTo: (options: { y: number; animated: boolean }) => void;
  } | null>;
  navScrollViewRef: RefObject<ScrollView | null>;
};
